export default function buildUrlWithAppId(to: string, appId: string | number | null | undefined): string {
  if (appId === null || appId === undefined || appId === '' || appId === 'null') {
    return to;
  }

  const hashIndex = to.indexOf('#');
  const pathAndSearch = hashIndex >= 0 ? to.slice(0, hashIndex) : to;
  const hash = hashIndex >= 0 ? to.slice(hashIndex) : '';
  const [pathname, optionSearch = ''] = pathAndSearch.split('?');
  const optionParams = new URLSearchParams(optionSearch);
  if (optionParams.has('appId')) {
    return to;
  }

  optionParams.set('appId', String(appId));
  return `${pathname}?${optionParams.toString()}${hash}`;
}
